import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "orders-map" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  class: "w-full h-full overflow-auto"
}, null, -1)
const _hoisted_3 = { class: "p-2 absolute bottom-1 p-2" }
const _hoisted_4 = { class: "bg-white p-2 shadow" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2\"><div class=\"w-3 h-3\" style=\"background-color:#62c454;\"></div> <span>Idle</span></div><div class=\"flex items-center gap-2\"><div class=\"w-3 h-3\" style=\"background-color:#4e57a9;\"></div> <span>Idle Assigned</span></div><div class=\"flex items-center gap-2\"><div class=\"w-3 h-3\" style=\"background-color:#ffd23f;\"></div> <span>In ward</span></div>", 3)
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-3 h-3",
  style: {"background-color":"#dd504b"}
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Others", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("ul", { class: "text-left text-xs" }, [
  /*#__PURE__*/_createElementVNode("li", null, "At the Darkstore"),
  /*#__PURE__*/_createElementVNode("li", null, "Inward Assigned"),
  /*#__PURE__*/_createElementVNode("li", null, "Ocuppied Outward"),
  /*#__PURE__*/_createElementVNode("li", null, "At the Address")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createVNode(_component_Popper, {
            arrow: "",
            hover: "",
            placement: "auto"
          }, {
            content: _withCtx(() => [
              _hoisted_12
            ]),
            default: _withCtx(() => [
              _createVNode(_component_BaseIcon, {
                name: "info",
                "class-names": "w-4 h-4"
              })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}